import Gallery from '@jetshop/ui/Gallery/Gallery';
import Badges from '@jetshop/ui/ProductList/Badges';
import React from 'react';
import { css, cx } from 'linaria';
import { styled } from 'linaria/react';
import { useSwitchToVariantImage } from '@jetshop/core/hooks/Product';
import { Favourite } from '../../ProductList/Favourite';
import { theme } from '../../Theme';

const Wrapper = styled('div')`
   display: flex;
   flex-direction: column;
   position: relative;

   ${theme.below.md} {
      .image-gallery-thumbnails-container {
         width: fit-content;
      }
   }
   .image-gallery-thumbnails-container {
      display: flex;
   }
   .image-gallery-thumbnail {
      &.active {
         border: 1px solid black;
      }
   }

   div[class^='badge-'] {
      left: 20px;
      top: 20px;
      ${theme.below.md} {
         left: 10px;
         top: 10px;
      }

      > * {
         background-color: var(--text-color);
         width: fit-content;
         margin-top: 10px;
         > span {
            font-weight: 700;
            padding: 7px 20px 6px 20px;
            text-transform: uppercase;
            color: var(--vit);
            font-size: var(--knapptext);
            letter-spacing: 0.1em;
            line-height: normal;
            ${theme.below.md} {
               padding: 5px 10px 5px 10px;
               font-size: 10px;
            }
         }
         &:first-child {
            margin-top: 0px;
         }
      }

      > .red {
         background-color: var(--red);
      }
      > .black {
         background-color: var(--text-color);
      }
   }
`;

const favourite = css`
   position: absolute;
   font-size: 1.5em;

   right: 22px;
   top: 24px;
   z-index: 1;
`;

export default function ImageContainer({
   images,
   selectedVariation,
   product,
   ...rest
}) {
   const galleryRef = React.createRef();
   // Enable switching gallery to image of selected variant
   useSwitchToVariantImage({
      galleryImages: images,
      galleryRef,
      variant: selectedVariation,
   });

   return (
      <Wrapper {...rest} className={rest.className}>
         <Favourite
            product={product}
            variant={selectedVariation}
            className={favourite}
         />
         <Gallery aspect={'1:1'} images={images} galleryRef={galleryRef}>
            <Badges badges={product.badges} />
         </Gallery>
      </Wrapper>
   );
}
